import React, {
    useCallback
} from 'react';
import { WizardPage, wizardProps } from 'e1p-portals-wizard-react';
import { EHHO4PropertyDetailsComponent } from 'e1p-capability-policyjob-react';

function PropertyPage(props) {
    const {
        wizardData: renewalVM
    } = props;

    const onNext = useCallback(
        () => renewalVM,
        [renewalVM]
    );

    return (
        <WizardPage
            onNext={onNext}
            shouldLink
        >
            <EHHO4PropertyDetailsComponent
                onValidate={() => {}}
                transactionVM={renewalVM}
                updateWizardData={() => {}}
                isPageSubmitted={false}
                setShouldSkipAdditionalInfo={() => {}}
                isSavingCurrentPageChanges={false}
                isSkipping={false}
                isSavingEndorsement={false}
                viewOnly
            />
        </WizardPage>
    );
}

PropertyPage.propTypes = wizardProps;
export default PropertyPage;